import dayjs from '@/utils/dayjs';

// 提前打开页面的密钥
export default function getCanEnterFlag(ecoflowid: string | null, timer?: number) {
    const date = dayjs.tz(timer, 'Asia/shanghai');
    const day = date.get('day');
    const id = ecoflowid || '';
    const t1 = id.slice(0, 1);
    const t2 = id.slice(1, 5);
    const t3 = id.slice(5, 7);
    const t4 = id.slice(7);

    //规则1--第1个字母为星期几的首字母
    const dayarr = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
    let flag1 = false;
    if (dayarr[day] === t1) {
        flag1 = true;
    }

    //规则2--第2-5的字符串为指定的字符串
    let flag2 = false;
    if (t2 === 'ecof') {
        flag2 = true;
    }

    //规则3--当前小时数+5月12日(512)这个数,有4个数的容量
    let flag3 = false;
    const randomH = 0;
    const hours = date.get('hour') + randomH;
    const keyhour = Number(t3 || '');
    const splitHour1 = 6;
    if (hours <= keyhour && keyhour <= hours + splitHour1) {
        flag3 = true;
    }

    const flagA = flag1 && flag2 && flag3;

    // 测试倒计时: 不能固定星期、时间、类型
    const flagTime = ecoflowid === 'test';
    // const flagTime = false;

    return {
        flag1: flagA && t4 === 'a', // 预热
        flag2: flagA && t4 === 'b', // 详情
        flag3: flagTime, // 早鸟
    };
}
